import { State } from "StateConstants";

export interface AvailableDependencyResult<TResult = unknown> {
  readonly state: State.Available;
  readonly value: TResult;
}

export interface NotAvailableDependencyResult {
  readonly state: State.NotAvailable;
  readonly value?: null;
}

export interface NotLoadedDependencyResult {
  readonly state: State.NotLoaded;
  readonly value?: null;
}

export interface NotAvailableOrLoadedDependencyResult {
  readonly state: State.NotAvailable | State.NotLoaded;
  readonly value?: null;
}

export type DependencyResult<TResult = unknown> =
  | AvailableDependencyResult<TResult>
  | NotAvailableOrLoadedDependencyResult;

export type LoadedDependencyResult<TResult = unknown> =
  | AvailableDependencyResult<TResult>
  | NotAvailableDependencyResult;

export function getAvailableResult<T>(value: T): AvailableDependencyResult<T> {
  return { state: State.Available, value };
}

export function getNotAvailableResult(): NotAvailableDependencyResult {
  // TODO: Convert to an immutable singleton object once entire codebase is using TypeScript.
  return { state: State.NotAvailable, value: null };
}

export function getNotLoadedResult(): NotLoadedDependencyResult {
  // TODO: Convert to an immutable singleton object once entire codebase is using TypeScript.
  return { state: State.NotLoaded, value: null };
}

export function getNullAvailableResult<T>(): AvailableDependencyResult<T | null> {
  // TODO: Convert to an immutable singleton object once entire codebase is using TypeScript.
  return { state: State.Available, value: null };
}
